function init() {
    const FAQButton = document.querySelectorAll('.single-faq-wrapper');
  
    if(FAQButton.length > 0){
        FAQButton.forEach(button => {
            button.addEventListener('click', (event)=>{
               event.target.classList.toggle('is-open');
               if ( event.target.children[1].style.maxHeight) {
                    event.target.children[1].style.maxHeight = null;
                } else {
                    event.target.children[1].style.maxHeight = event.target.children[1].scrollHeight + "px";
                } 
            })
        })
    }


}

export { init as default };
